import { CreatecustomfromComponent } from "./createcustomfrom/createcustomfrom.component";
import { CustomFormComponent } from "./custom-form.component";
import { EditcustomfromComponent } from "./editcustomfrom/editcustomfrom.component";
import { ViewcustomfromComponent } from "./viewcustomfrom/viewcustomfrom.component";

export const CustomFromDeclaration = [
    CreatecustomfromComponent,EditcustomfromComponent,ViewcustomfromComponent,CustomFormComponent
]